@for (tab of tabs(); track tab.value) {
  <div class="nav-item" [attr.data-qa]="tab.testId" (click)="changeTab.emit(tab.value)" [ngClass]="{ active: !!tab.active }">
    <span class="nav-link"> 
      <rx-icon *ngIf="tab.icon" [name]="tab.icon" class="nav-icon" /> 
      {{ tab.label }} 
    </span>
  </div>
}
